module.exports = __webpack_public_path__ + "static/media/home.9e62ff1d.svg";